import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import MKBox from "components/MKBox";
import ServiceGuidance from "components/ServiceGuidance";
import RotatingCard from "examples/Cards/RotatingCard";
import RotatingCardFront from "examples/Cards/RotatingCard/RotatingCardFront";
import RotatingCardBack from "examples/Cards/RotatingCard/RotatingCardBack";

import bgFront5 from "assets/images/servicii/bgFront5.webp";
import bgBack5 from "assets/images/servicii/bgBack5.webp";

const advantages = {
    paragraphs: [
        "Oferim servicii profesionale de întreținere, abonamente periodice sau procese complete de curățare în profunzime și tratamente aplicate pardoselilor.",
        "Specialiștii noștri sunt calificați în curățarea și tratarea tuturor tipurilor de pardoseli, având experiență în proiecte de mari dimensiuni.",
        "Folosim mașini și utilaje automatizate cu randament ridicat, care permit executarea rapidă și eficientă a lucrărilor pe suprafețe extinse.",
    ],
};

const advice = {
    paragraphs: [
        "Pentru spațiile cu trafic redus sau mediu, unde întreținerea zilnică se face doar prin spălare cu mopul, recomandăm o spălare mecanizată la 2–3 zile. Aceasta ajută la eliminarea murdăriei depuse și a granulelor fine de nisip, reducând uzura și deteriorarea pardoselii.",
        "Protejați și sigilați pardoselile încă din stadiul de noi pentru a vă proteja investiția pe termen lung.",
        "Pentru pardoselile din lemn, respectați fișa de întreținere și folosiți doar produsele recomandate de producător.",
    ],
};

function InformationHome() {
    return (
        <MKBox component="section" py={6} my={6}>
            <Container>
                <Grid container spacing={4} alignItems="stretch">
                    <Grid item xs={12} lg={4}>
                        <RotatingCard>
                            <RotatingCardFront
                                image={bgFront5}
                                icon="touch_app"
                                title="Curățarea pardoselilor"
                                description="Tehnici adaptate materialului, murdăriei și caracteristicilor tehnice."
                            />
                            <RotatingCardBack
                                image={bgBack5}
                                title="Echipamente moderne"
                                description="Solicită o evaluare gratuită."
                                action={{
                                    type: "internal",
                                    route: "/contact-curatenie",
                                    label: "cere o ofertă",
                                }}
                            />
                        </RotatingCard>
                    </Grid>
                    <Grid item xs={12} lg={8}>
                        <ServiceGuidance advantages={advantages} advice={advice} />
                    </Grid>
                </Grid>
            </Container>
        </MKBox>
    );
}

export default InformationHome;
